<app-menu></app-menu>

<div class="d-flex flex-nowrap">
  <app-sidebar class="d-none d-lg-block" />
  <div class="main p-5 flex-fill">
    <toast-container></toast-container>
    @defer (on idle; on timer(300)){
      <router-outlet ></router-outlet>
    } @placeholder (minimum 0) {
      <div></div>
    } @error {
      <div>
        Some error occurred while loading component
      </div>
    }
  </div>
</div>
